module.exports = {
  message: {
    Home_Title: '大灣區金融科技總會',
    Home_Lang: '繁體中文',

    Home_Tc: '題詞',
    Home_objective: '我們的宗旨',
    Home_objective_1: '專註金融科技',
    Home_objective_2: '團結凝聚金融、科技界企業及專業人士,積極參與大灣區建設,促進大灣區金融科技發展',
    Home_objective_3: '「依托香港、服務內地、面向世界」,充分發揮香港國際金融中心優勢,促進大灣區與國際交流、接軌',
    Home_objective_4: '積極對接資源,促進業界交流合作,推動創新金融產品轉化與落地',
    Home_objective_5: '為大灣區青年創造更多發展機會,培養新時代經濟的建設者和接班人',
    Home_objective_6: '為大灣區金融科技行業提供壹個服務平臺,加強業界培訓,提升金融創科力量',
    Home_objective_7: '建立金融科技應用,安全及產品認證體系,推動行業發展與國際領先水平接軌',


    Home_work: '我們的工作',
    Home_work_1: '搭建交流平臺',
    Home_work_2: '發揮橋樑作用',
    Home_work_3: '促進項目落地',
    Home_work_4: '著力培育青年',
    Home_work_5: '提供專業培訓',
    Home_work_6: '提供資訊服務',
    Home_work_7: '建立認證體系',


    Home_wish: '我們的願景',
    Home_wish_1: '更多有國際影響力的金融科技企業',
    Home_wish_2: '更多有潛力的金融科技專案落地',
    Home_wish_3: '更多高端的金融科技人才',
    Home_wish_4: '更多充滿魅力和夢想的青年',



    Home_Download:'更多精彩資訊，下載app',
    Home_Focus:'更多關註',
    Home_Address:'地址：香港尖沙咀廣東道9號港威大廈6座25樓2507室',
    Home_PhoneNumber:'電話',
    Home_Fax:'傳真',
    Home_Email:'郵箱',
    Home_Url:'網址',
    Home_Copyright:'大灣區金融科技總會 版權所有',
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/lang/zhCHT.js
// module id = ZpxJ
// module chunks = 0